module.exports = __webpack_public_path__ + "img/check--green.455ba497.svg";